import { CSSObject, Theme, getFontWeight } from '@core-ui/react-stitch';

const getTextStyles = (theme: Theme, isBR: boolean, isBRRedesignEnabled: boolean): CSSObject => {
  const brFontWeight = isBR
    ? getFontWeight('regular')
    : getFontWeight('bold');
  return {
    borderBottom: 'none',
    color: theme.color.b1,
    fontSize: '1rem',
    fontWeight: brFontWeight.fontWeight,
    textTransform: 'uppercase',
    ...isBRRedesignEnabled
      ? {
        color: theme.color.inverse.b1,
        textTransform: 'capitalize',
        textAlign: 'right',
        fontWeight: getFontWeight('book').fontWeight,
        fontSize: '0.9rem'
      }
      : {}
  };
};

export default getTextStyles;
